interface SEOHeadProps {
  title: string;
  description: string;
  keywords: string;
  canonicalUrl: string;
  ogType?: string;
}

export default function SEOHead({ title, description, keywords, canonicalUrl, ogType = 'website' }: SEOHeadProps) {
  const updateMeta = () => {
    document.title = title;
    const setMeta = (name: string, content: string, isProperty = false) => {
      const attr = isProperty ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };
    setMeta('description', description);
    setMeta('keywords', keywords);
    const link = document.querySelector('link[rel="canonical"]');
    if (link) link.setAttribute('href', canonicalUrl);
    setMeta('og:title', title, true);
    setMeta('og:description', description, true);
    setMeta('og:url', canonicalUrl, true);
    setMeta('og:type', ogType, true);
    setMeta('twitter:title', title);
    setMeta('twitter:description', description);
  };

  // Use useEffect-style inline execution
  if (typeof document !== 'undefined') {
    setTimeout(updateMeta, 0);
  }

  return null;
}